import script from "./TooltipContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./TooltipContent.vue?vue&type=script&setup=true&lang=ts"

import "./TooltipContent.vue?vue&type=style&index=0&id=70145c52&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70145c52"]])

export default __exports__